import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { BASEURL } from "../../constants";
import toast from 'react-hot-toast';
import PublishCourseModal from "./PublishCourseModal";
import DeleteCourseModal from "./DeleteCourseModal";
import { formatClassId, formatTags } from '../../Utils/utilFunctions'
import CourseCard from "../Global/CourseCard/CourseCard";
import { useNavigate } from "react-router-dom";
import CourseCardList from "../Global/CourseCard/CourseCardList";

const DraftCourses = ({ searchTerm, courseArray, setDraftCourses, onPublishSccuess, viewToggle }) => {
    console.log("draft courses called")
    const [userCourses, setUserCourses] = useState([]);

    const [showDeleteModal, setShowDeleteModal] = useState({
        state: false,
        courseId: null,
    });
    const [filteredData, setFilteredData] = useState([]); // Fil    tered school data for display

    const [showPublishModal, setShowPublishModal] = useState(false);
    const [coverImages, setCoverImages] = useState({});

    const navigate = useNavigate();


    const handlePublishClick = (courseId) => {
        setShowPublishModal({ state: true, courseId });
    };

    useEffect(() => {
        const filtered = courseArray.filter(course =>
            course.course_name && course.course_name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        console.log("filtered courses" , filtered)
        setFilteredData(filtered);
    }, [searchTerm, courseArray]);

    function deleteCourse(courseId) {
        axios.delete(`${BASEURL}/api/delete-course`, {
            params: { courseId: courseId },
        }).then((response) => {
            if (response.data.status === "success") {
                console.log("setting the userCourses for course delete")
                // setUserCourses(userCourses => userCourses.filter(course => course.id !== courseId));
                setDraftCourses((draftCourses) => {
                    return draftCourses.filter( course => course.id !== courseId)
                })
                setShowDeleteModal({ show: false, courseId: null, imported: false })
            }
        });
    }

    const handlePublishSuccess = (courseId, status) => {
        console.log('Course publish status:', status); // Log the updated status
        setUserCourses(prevCourses =>
            prevCourses.map(course =>
                course.id === courseId
                    ? { ...course, verify_status: 'pending', course_status: 'completed' }
                    : course
            )
        );
    };

    const courseCardClickHandler = (courseId) => {
        navigate(`/course-builder/${courseId}`)
    }

    return (
        <>
            <PublishCourseModal
                isOpen={showPublishModal.state}
                onClose={() => setShowPublishModal({ state: false, courseId: null })}
                id={showPublishModal.courseId}
                onPublishSuccess={onPublishSccuess} // Pass the onPublishSuccess callback
            />

            <DeleteCourseModal showDeleteModal={showDeleteModal} setShowDeleteModal={setShowDeleteModal} deleteCourse={deleteCourse} />

            <div className={viewToggle =="tile" ? "rounded-md" : "flex flex-wrap gap-6"}>
                {filteredData.length === 0 ? (
                    <div className="col-span-full w-full my-0 mx-auto">
                        <div className="flex justify-center my-0 mx-auto w-full">
                            <div className="flex flex-col items-center text-center max-w-sm">
                                <p className="p-3 text-sm font-medium text-blue-500 rounded-full bg-blue-50">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="w-6 h-6 flex justify-center">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
                                    </svg>
                                </p>
                                <p className="text-xl font-bold mt-2 text-gray-700">Oops! No courses found.</p>
                                <p className="mt-2">It looks like there are no courses here. Why not create one and get started?</p>
                            </div>
                        </div>
                    </div>
                ) : (
                    filteredData.map((course, index) => {
                        return (
                            viewToggle=="tile"?
                            <CourseCardList type='draft' course={course} courseId={course.id} onClickHandler={courseCardClickHandler} setShowDeleteModal={setShowDeleteModal} handlePublishClick={handlePublishClick} />
                            :
                            <CourseCard type='draft' course={course} courseId={course.id} onClickHandler={courseCardClickHandler} setShowDeleteModal={setShowDeleteModal} handlePublishClick={handlePublishClick} />
                        )
                    })

                )}
            </div>
        </>
    )
}

export default DraftCourses
